import { render } from "./ApplicantDetailsView.vue?vue&type=template&id=272fed90&scoped=true"
import script from "./ApplicantDetailsView.vue?vue&type=script&lang=js"
export * from "./ApplicantDetailsView.vue?vue&type=script&lang=js"

import "./ApplicantDetailsView.vue?vue&type=style&index=0&id=272fed90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272fed90"]])

export default __exports__